import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'large';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 免费韩国漫画在线阅读-韩漫网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>

        <div className="absolute top-3 left-3">
          <span
            className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-accent-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>

        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-1 text-accent-400 text-xs mb-1">
            <i className="ri-star-fill"></i>
            <span className="font-semibold">{comic.rating}</span>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1 line-clamp-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-1">
        {comic.author} &middot; {comic.category}
      </p>
    </Link>
  );
}

export { type ComicCardProps };